import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { NudgeDTO } from 'src/app/model/communication/nudge-dto.model';
import { NudgeObservationDTO } from 'src/app/model/communication/nudge-observation-dto.model';
import { NotifyOfCommentDTO } from 'src/app/model/communication/notify-of-comment-dto.model';

@Injectable()
export class MessagingApi extends BaseApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getMessage(messageRecipientId: string) {
        return this.http.get(`${this.baseUri}/message/GetMessage/${messageRecipientId}`);
    }

    messages(offset?: number, limit?: number, orderBy?: string, ascending?: boolean, searchBy?: string, start?:string, end?:string) {
        let params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('ascending', String(ascending ?? true))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        if (searchBy) {
            params = params.append('searchBy', this.convertParam(searchBy));
        }

        if (start) {
            params = params.append('start', this.convertParam(start));
        }

        if (end) {
            params = params.append('end', this.convertParam(end));
        }

        return this.http.get(this.baseUri + '/message/messages', {
            params
        });
    }

    nudge(nudge: NudgeDTO) {
        return this.http.put(this.baseUri + '/message/nudge', nudge);
    }

    nudgeObservation(nudgeObservation: NudgeObservationDTO) {
        return this.http.put(`${this.baseUri}/message/nudgeObservation`, nudgeObservation);
    }

    notifyOfComment(notifyOfCommentDTO: NotifyOfCommentDTO) {
        return this.http.put(`${this.baseUri}/message/notifyOfComment`, notifyOfCommentDTO);
    }
}